var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiFiIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8471 16.8801C22.0508 17.0837 22.0944 17.3892 21.9635 17.6364C21.4981 18.4801 20.3344 18.8583 19.4617 18.2037C17.4108 16.6764 14.589 16.7055 12.5671 18.2037C11.6944 18.8583 10.5308 18.4801 10.0653 17.6364C9.93442 17.3892 9.97806 17.0837 10.1817 16.8801C13.3671 13.6364 18.6181 13.6219 21.8471 16.8801Z",
    fill: "#C0C8D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6762 15.9198C18.9235 12.2253 13.0181 12.2835 9.30897 15.9198C9.14897 16.0798 8.91624 16.138 8.69806 16.0944C8.01442 15.9198 7.50533 15.338 7.44715 14.6398C7.4326 14.4508 7.50533 14.2617 7.63624 14.1162C12.2908 9.57802 19.6944 9.59256 24.3344 14.1162C24.4799 14.2471 24.5381 14.4362 24.5235 14.6398C24.4653 15.338 23.9562 15.9198 23.2726 16.0944C23.069 16.138 22.8362 16.0653 22.6762 15.9198Z",
    fill: "#C0C8D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4727 13.2581C26.4145 13.3163 26.3563 13.36 26.2982 13.4036C26.0509 13.6072 25.6872 13.5781 25.4545 13.3454C20.2472 8.07996 11.7527 8.06541 6.54542 13.3454C6.3127 13.5781 5.93451 13.6072 5.68724 13.389C5.6436 13.36 5.59997 13.3163 5.57088 13.2872C4.79997 12.5309 4.91633 11.4254 5.62906 10.829C11.5927 5.73814 20.4363 5.73814 26.4 10.829C27.1272 11.4545 27.1563 12.5745 26.4727 13.2581Z",
    fill: "#C0C8D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23.4546C16.948 23.4546 17.7164 22.6861 17.7164 21.7382C17.7164 20.7903 16.948 20.0219 16 20.0219C15.0521 20.0219 14.2837 20.7903 14.2837 21.7382C14.2837 22.6861 15.0521 23.4546 16 23.4546Z",
    fill: "#C0C8D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiFiIcon);
export default __webpack_public_path__ + "static/media/wi-fi_icon.8de328e4b3566b96bc29bad84633bd6d.svg";
export { ForwardRef as ReactComponent };